import { useEffect } from 'react';
import { useLocation } from 'react-router';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    globalThis.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
